import type { Figure } from '@/types/content';

export const figures: Figure[] = [
  {
    id: 'fig-01',
    name: '沈砚舟',
    alias: '档案编号 D-1042',
    field: '影视',
    era: '1994 — 2016',
    region: '华北',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20monochrome%20editorial%20portrait%20of%20an%20anonymous%20man%20in%20shadow%2C%20cinematic%20side%20lighting%2C%20film%20grain%2C%20deep%20charcoal%20backdrop%2C%20mysterious%20archive%20mood%2C%20high%20contrast%2C%20no%20identifiable%20features&width=600&height=800&seq=fig-01-shen&orientation=portrait',
    summary:
      '以夜戏与长镜头闻名的一代导演，二十余年间经历三次临阵换角、一次署名争议。档案室保留了他未公开的分镜手稿与场记单。',
    tags: ['临阵换角', '署名争议', '夜戏'],
    recordCount: 46,
    heat: 96,
  },
  {
    id: 'fig-02',
    name: '林令仪',
    alias: '档案编号 D-0871',
    field: '影视',
    era: '1998 — 2019',
    region: '华东',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20monochrome%20editorial%20portrait%20of%20an%20anonymous%20woman%20in%20shadow%2C%20soft%20rim%20light%2C%20film%20grain%2C%20aged%20paper%20texture%20overlay%2C%20quiet%20archival%20atmosphere%2C%20high%20contrast%2C%20no%20identifiable%20features&width=600&height=800&seq=fig-02-lin&orientation=portrait',
    summary:
      '从话剧舞台走向银幕的演员，留下大量被剪掉的试镜资料。她的档案件数不多，却几乎每一件都牵出同期的选角内幕。',
    tags: ['试镜资料', '选角内幕', '话剧出身'],
    recordCount: 31,
    heat: 88,
  },
  {
    id: 'fig-03',
    name: '苏亦棠',
    alias: '档案编号 D-1207',
    field: '电视',
    era: '2001 — 2021',
    region: '华南',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20monochrome%20editorial%20portrait%20of%20an%20anonymous%20presenter%20in%20shadow%2C%20studio%20spotlight%2C%20film%20grain%2C%20dark%20grey%20backdrop%2C%20broadcast%20archive%20mood%2C%20high%20contrast%2C%20no%20identifiable%20features&width=600&height=800&seq=fig-03-su&orientation=portrait',
    summary:
      '黄金时段主持人，一次直播口误后淡出荧屏。档案中心整理了她前后五年的节目单与通告记录，还原那段被简化的时间线。',
    tags: ['直播事故', '节目单', '淡出荧屏'],
    recordCount: 27,
    heat: 79,
  },
  {
    id: 'fig-04',
    name: '顾长风',
    alias: '档案编号 D-0633',
    field: '音乐',
    era: '1992 — 2013',
    region: '华北',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20monochrome%20editorial%20portrait%20of%20an%20anonymous%20music%20producer%20in%20shadow%2C%20warm%20lamp%20light%2C%20film%20grain%2C%20old%20studio%20equipment%20backdrop%2C%20moody%20archival%20atmosphere%2C%20high%20contrast%2C%20no%20identifiable%20features&width=600&height=800&seq=fig-04-gu&orientation=portrait',
    summary:
      '缔造过多张畅销专辑的制作人，因版权分配与老东家分道扬镳。档案室收录了当年的合约复印件与录音室日志摘要。',
    tags: ['版权分配', '合约风波', '录音室日志'],
    recordCount: 38,
    heat: 91,
  },
  {
    id: 'fig-05',
    name: '江雪桥',
    alias: '档案编号 D-0918',
    field: '影视',
    era: '2003 — 2022',
    region: '华东',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20monochrome%20editorial%20portrait%20of%20an%20anonymous%20writer%20in%20shadow%2C%20desk%20lamp%20glow%2C%20film%20grain%2C%20stacked%20manuscript%20backdrop%2C%20literary%20archive%20mood%2C%20high%20contrast%2C%20no%20identifiable%20features&width=600&height=800&seq=fig-05-jiang&orientation=portrait',
    summary:
      '署名争议缠身的编剧，多部作品的最终剧本与初稿差异巨大。档案中心按时间顺序比对了六个版本的修改痕迹。',
    tags: ['署名争议', '剧本比对', '改稿记录'],
    recordCount: 34,
    heat: 84,
  },
  {
    id: 'fig-06',
    name: '白霜',
    alias: '档案编号 D-0557',
    field: '音乐',
    era: '2006 — 2019',
    region: '西南',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20monochrome%20editorial%20portrait%20of%20an%20anonymous%20singer%20in%20shadow%2C%20stage%20haze%20and%20backlight%2C%20film%20grain%2C%20dark%20curtain%20backdrop%2C%20concert%20archive%20mood%2C%20high%20contrast%2C%20no%20identifiable%20features&width=600&height=800&seq=fig-06-bai&orientation=portrait',
    summary:
      '从选秀舞台爆红又迅速沉寂的歌手，五年空白期始终没有正式说法。档案室据公开通告整理出一条相对完整的活动时间轴。',
    tags: ['选秀', '空白期', '时间轴'],
    recordCount: 22,
    heat: 82,
  },
  {
    id: 'fig-07',
    name: '陆时安',
    alias: '档案编号 D-1389',
    field: '影视',
    era: '1989 — 2011',
    region: '华南',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20monochrome%20editorial%20portrait%20of%20an%20anonymous%20executive%20in%20shadow%2C%20boardroom%20lighting%2C%20film%20grain%2C%20city%20window%20backdrop%2C%20business%20archive%20mood%2C%20high%20contrast%2C%20no%20identifiable%20features&width=600&height=800&seq=fig-07-lu&orientation=portrait',
    summary:
      '老牌工作室的出品人，见证了一家公司从崛起到收缩的全过程。档案室保留了他离职前后的项目排期表残页。',
    tags: ['工作室兴衰', '项目排期', '离职'],
    recordCount: 29,
    heat: 76,
  },
  {
    id: 'fig-08',
    name: '温以宁',
    alias: '档案编号 D-0264',
    field: '传媒',
    era: '1996 — 2018',
    region: '华北',
    cover:
      'https://readdy.ai/api/search-image?query=Stylized%20monochrome%20editorial%20portrait%20of%20an%20anonymous%20journalist%20in%20shadow%2C%20window%20light%20and%20film%20grain%2C%20newspaper%20stack%20backdrop%2C%20press%20archive%20mood%2C%20high%20contrast%2C%20no%20identifiable%20features&width=600&height=800&seq=fig-08-wen&orientation=portrait',
    summary:
      '长期跟踪娱乐行业的资深记者，其未刊发的采访笔记是很多旧事的重要旁证。档案中心对其笔记做了去个人化的整理。',
    tags: ['采访笔记', '未刊稿', '旁证'],
    recordCount: 41,
    heat: 87,
  },
];